<template>
  <div class="wrapper-hidden-fields">
    <v-row>
      <v-col cols="12">
        <v-text-field label="Label" v-model="form.label" outlined />
        <v-text-field
          label="Código do Campo (field_code)"
          v-model="form.fieldName"
          outlined
        />
        <v-btn class="mr-4" @click="resetForm">Limpar</v-btn>
        <v-btn color="primary" @click="handleClickSave">
          {{ 'Cadastrar' }}
        </v-btn>
      </v-col>
      <v-col cols="12">
        <div class="card-list-wrapper">
          <div class="card-list">
            <v-card
              class="mb-3"
              v-for="item in adminHiddenFields"
              :key="item.id"
            >
              <div>
                <v-card-title>{{ item.label }}</v-card-title>
                <v-card-subtitle v-if="item.fieldName">
                  {{ item.fieldName }}
                </v-card-subtitle>
              </div>
              <v-card-actions>
                <v-btn icon title="remover" @click="handleClickRemove(item.id)">
                  <v-icon>remove</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FormHiddenFieldsComponent',
  data: () => ({
    form: {
      id: '',
      label: '',
      fieldName: '',
    },
  }),
  computed: {
    ...mapState({
      adminHiddenFields: state => state.admin.adminHiddenFields,
    }),
  },
  methods: {
    resetForm() {
      this.form.label = '';
      this.form.fieldName = '';
      this.form.id = '';
    },
    async handleClickSave() {
      if (!this.form.label || !this.form.fieldName) {
        this.$store.dispatch('snackbar/showSnackbarWithMessage', {
          message: 'Preencha todos os campos.',
          type: 'error',
        });
        return;
      }

      const payload = {
        label: this.form.label,
        fieldName: this.form.fieldName,
      };

      await this.$store.dispatch('admin/createHiddenField', payload);

      this.resetForm();
    },
    async handleClickRemove(id) {
      await this.$store.dispatch('admin/deleteHiddenField', id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';

.wrapper-hidden-fields {
  width: 700px;
  min-height: 50vh;
  overflow: hidden;
}

::v-deep {
  .v-input {
    &.v-input--is-focused {
      label {
        left: 0 !important;
      }
    }
    &.v-input--is-label-active {
      label {
        left: 0 !important;
      }
    }
  }

  .v-text-field {
    &.v-text-field--outlined {
      .v-label--active {
        transform: translateY(-18px) scale(0.75) !important;
        padding-left: 0 !important;
      }
    }
  }
}

.card-list-wrapper {
  width: 100%;

  .card-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 24px 16px;
    box-sizing: border-box;

    .v-card {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      &__title {
        font-size: 1.2rem;
      }
      &__subtitle {
        color: #808080;
      }
    }

    @include for-size(phone-only) {
      display: block;
      width: 100%;
      padding: 16px;
      box-sizing: border-box;
    }
  }
}
</style>
